<script setup>
import { ref, onMounted, onUnmounted, inject, watch} from 'vue'
import { useWorkspaceStore } from '@stores/WorkspaceData';
const wpStore = useWorkspaceStore()
import { tarService } from '@requests/Main/target.service';
const toast = inject('toast')
// Автосохранение подключаем после загрузки данных, чтобы открытие вкладки не вызывало PUT
let stopAutoSave = null
onMounted(async () => {
  experiment.value = wpStore.experiment
  stopAutoSave = watch(() => experiment.value.Tar, () => debouncedSave(), {deep: true})
})
onUnmounted(() => {
  stopAutoSave?.()
  debouncedSave.flush()
})
const Save = async () => {
  let data = await tarService.Put(experiment.value.Tar)
  return data
}

const experiment = ref({Sat: null,Tar:null})
import Fieldset from 'primevue/fieldset';
import { debounce } from 'lodash-es'

const debouncedSave = debounce(() => {
  Save()
}, 500)

import VisibilityCard from './Visibility.vue';
import TurnaroundTime from './TurnaroundTime.vue';
import FlightMission from './FlightMission.vue';
</script>

<template>
<section v-if="experiment.Tar" class="SectionPanel">
<Fieldset legend="Информация">
    <div class="fieldsetDiv">
      <FloatLabel variant="on">
        <InputText v-model="experiment.Tar.name" size="small" style="width: 100%;"/>
        <label>Название</label>
      </FloatLabel>
    </div>
    <div class="fieldsetDiv">
      <FloatLabel variant="on">
        <InputNumber  v-model="experiment.Tar.latitude" :maxFractionDigits="2" size="small" style="width: 100%;"/>
        <label>Широта</label>
      </FloatLabel>
    </div>
    <div class="fieldsetDiv">
      <FloatLabel variant="on">
        <InputNumber  v-model="experiment.Tar.longitude" :maxFractionDigits="2" size="small" style="width: 100%;"/>
        <label>Долгота</label>
      </FloatLabel>
    </div>
</Fieldset>

<VisibilityCard />
<TurnaroundTime />
<FlightMission />
</section>
</template>

<style>
.p-splitterpanel .ToolbarPanel{
    border: none;
    border-bottom: 1px solid var(--p-toolbar-border-color);
    border-radius: 0px;
    padding: 5px;
    position: sticky;
    top: 0px;
    z-index: 5;
}
.p-splitterpanel .SectionPanel{
    display: flex;
    flex-wrap: wrap;
}
.SectionPanel .p-fieldset{
  width: fit-content;
}
.SectionPanel .p-fieldset .p-fieldset-content{
    display: flex;
    gap: 20px;
    flex-direction: column;
}
.SectionPanel .FieldsetTable th{
    color: var(--p-floatlabel-active-color);
    font-size: var(--p-floatlabel-active-font-size);
    font-weight: var(--p-floatlabel-active-font-weight);
    text-align: start;
}
.smallInput input{
  width: 50px;
}
</style>